import { Component, Input } from '@angular/core';
import { IDeviceContract, LoggerService } from '@nx-fe/services';

import { Enums } from '../../../../../../../../libs/services/enums/enums';
import { DlgConfirmActionService } from '../services/dlg-confirm-action.service';

@Component({
  selector: 'app-details-header',
  templateUrl: './details-header.component.html',
  styleUrls: ['./details-header.component.scss'],
})
export class DetailsHeaderComponent {
  replace = true;
  restrict = 'A';
  bindToController = true;
  controllerAs = 'ui';
  actions = null;

  @Input()
  device: IDeviceContract;

  private logPrefix = 'mcDetailsHeader: ';

  constructor(private dialogConfirmActionService: DlgConfirmActionService, private $log: LoggerService) {}

  onActionClick = ($event, actionName) => {
    const deviceAction = Enums.DeviceActions[actionName];
    this.dialogConfirmActionService.openDialog(this.device as any, deviceAction).subscribe(
      result => {
        // this.$log.debug(this.logPrefix + 'DialogConfirmAction.show() resolved with result:', result);
      },
      error => {
        // this.$log.debug(this.logPrefix + 'DialogConfirmAction.show() reject with error:', error);
      }
    );
  };
}
